<template>
  <div class="container">
    <div class="top-bg">
    <!--  <div class="return" @click="linkindex">
        <span>返回首页</span>
      </div>-->
    </div>

    <div class="img">

      <img src="../../static/images/qie01.jpg" alt="">
      <ul class="breadnav ct-centre">
        <li @click="linkytowin"> <img src="../../static/images/icon_logo.png" alt=""></li>
        <li class="icon">&gt;</li>
        <li @click=" linkindex">专题首页</li>
        <li class="icon">&gt;</li>
        <li>课程介绍</li>
      </ul>
      <img src="../../static/images/qie02.jpg" alt="">
      <img src="../../static/images/qie03.jpg" alt="">
      <img src="../../static/images/qie04.jpg" alt="">
      <img src="../../static/images/qie05.jpg" alt="">
      <img src="../../static/images/qie06.jpg" alt="">
      <img src="../../static/images/qie07.jpg" alt="">
    </div>
    <floatewm class="floatewm"></floatewm>
  </div>
</template>

<script>
import floatewm from "../components/floatewm";

export default {
  components: {
    floatewm: floatewm
  },
  methods: {
    linkindex() {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>
<style lang="less" scoped>

.container {
  width: 100%;
  min-width: 1200px;

  .top-bg {
    position: relative;
 /*   .return {
      width: 1200px;
      margin: 0 auto;
 !*     position: absolute;*!
      position: relative;
      span {
        cursor: pointer;
        left: 97%;
        top: -15px;
        padding: 95px 7px 5px 7px;
        color: #fff;
        text-align: center;
        width: 30px;
        height: 160px;
        position: absolute;
        background: url("../../static/images/return-x.png") no-repeat;
        background-size: 100%;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
      }
      span:hover {
        top: 0px;
      }
    }
    .top-bgtu {
      width: 100%;
      min-width: 1200px;
    }*/
  }

  .img{
    .breadnav{
      margin: 20px auto;
      li{
        display: inline-block;
        color: #5bab52;
        cursor: pointer;
        &:last-child{
          color: #5bab52;
        }
        img{
          width: 78px;
          height: 33px;
          vertical-align: middle;
        }
      }
      .icon{
        color: #5bab52;
      }
    }
    img{
      width: 100%;
      height: 100%;
    }
  }

  .floatewm {
    z-index: 99;
    position: fixed;
    right: 17px;
    top: 48%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/penguin.vue